var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-input", {
    staticClass: "comment-textarea",
    attrs: {
      type: "textarea",
      rows: 10,
      placeholder: "Schreibe einen Kommentar"
    },
    on: { change: _vm.inputChange },
    model: {
      value: _vm.comment,
      callback: function($$v) {
        _vm.comment = $$v
      },
      expression: "comment"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c15312d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c15312d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/order/InputTemplate.vue
// module id = null
// module chunks = 